module.exports = __webpack_public_path__ + "img/referal-buy-tariff-2.9c4623fb.svg";